import { render, staticRenderFns } from "./Names.vue?vue&type=template&id=0f5f1b26&"
import script from "./Names.vue?vue&type=script&lang=js&"
export * from "./Names.vue?vue&type=script&lang=js&"
import style0 from "./Names.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports